<template>
  <div class="wrapBox">
    <div class="screenBox">
      <el-radio-group v-model="searchFormData.type" style="margin-right:40px" @change="agreeChange()">
        <el-radio-button label="1">日</el-radio-button>
        <el-radio-button label="2">周</el-radio-button>
        <el-radio-button label="3">月</el-radio-button>
      </el-radio-group>
      <el-date-picker
          v-show="searchFormData.type =='1'"
          v-model="searchFormData.startTime"
          value-format="timestamp"
          @change="changeRangDate()"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-date-picker
          v-show="searchFormData.type =='2'"
          v-model="searchFormData.rangDate"
          value-format="timestamp"
          @change="changeRangDate()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <el-date-picker
          v-show="searchFormData.type =='3'"
          v-model="searchFormData.startTime"
          value-format="timestamp"
          @change="changeRangDate()"
          type="month"
          placeholder="选择日期"
          :picker-options="pickerOptions"
      >
      </el-date-picker>
    </div>
    <div class="contentBox">
      <div class="dataBox">
        <div class="titleBox">应用概况</div>
        <div class="data">
          <div class="title">数据概况</div>
          <hr class="hr">
          <p><span>活跃链接数量</span><span>{{ appData.activeLinkCount }}</span></p>
          <p><span>应用链接总访问量</span><span>{{ appData.newVisitCount }}</span></p>
          <p><span>应用链接总访问用户</span><span>{{ appData.newAccountVisitCount }}</span></p>
          <p><span>链接总分发量</span><span>{{ appData.distributionCount }}</span></p>

        </div>
        <div class="data">
          <div class="title">单链接平均数据</div>
          <hr class="hr">
          <p><span>平均链接访问量</span><span>{{ appData.avgVisitCount }}</span></p>
          <p><span>平均链接访问用户</span><span>{{ appData.avgAccountVisitCount }}</span></p>
          <p><span>平均链接访问分发量</span><span>{{ appData.avgDistributionCount }}</span></p>
        </div>
        <div class="data">
          <div class="title">累计数据</div>
          <hr class="hr">
          <p><span>累计应用链接数量</span><span>{{ appData.appLinkCount }}</span></p>
          <p><span>累计应用链接总访问量</span><span>{{ appData.totalVisitCount }}</span></p>
          <p><span>累计应用链接总访问用户</span><span>{{ appData.totalAccountVisitCount }}</span></p>
          <p><span>累计链接总分发量</span><span>{{ appData.totalDistributionCount }}</span></p>
        </div>
      </div>
      <div class="appPieBox">
        <div class="titleBox">应用单链接访问分布</div>
        <el-row>
          <el-col :span="24">
            <div id="appPieChart"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="listBox">
      <h1 class="title">TOP10 链接明细数据</h1>
      <el-table
          class="tableBox"
          :data="tableData"
          stripe
          style="width: 100%"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }">

        <el-table-column
            width="50"
            type="index"
            label="序号">
        </el-table-column>
        <el-table-column
            width="120"
            prop="link_name"
            label="链接名称">
        </el-table-column>
        <el-table-column
            width="120"
            prop="android_deeplink"
            label="链接地址">
        </el-table-column>
        <el-table-column
            width="120"
            prop="create_time"
            label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="全部">
          <el-table-column
              prop="new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="华为">
          <el-table-column
              prop="huawei_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="huawei_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="OPPO">
          <el-table-column
              prop="oppo_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="oppo_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="vivo">
          <el-table-column
              prop="vivo_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="vivo_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="小米">
          <el-table-column
              prop="xiaomi_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="xiaomi_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>

        <el-table-column
            label="iOS">
          <el-table-column
              prop="ios_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="ios_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="其他">
          <el-table-column
              prop="other_new_visit_count"
              label="访问量">
          </el-table-column>
          <el-table-column
              prop="other_new_account_visit_count"
              label="访问用户">
          </el-table-column>
        </el-table-column>
        <el-table-column
            width="120"
            prop="distribution_count"
            label="分发量">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date(new Date().toLocaleDateString()).getTime()

        },
      },
      myPancakeChart: "",
      appData: {},
      tableData: [],
      searchFormData: {
        id: '',
        type: "1",
        rangDate: [new Date().setHours(0, 0, 0, 0) - 8.64e7 * 7, new Date().setHours(0, 0, 0, 0) - 1000],
        startTime: new Date().setHours(0, 0, 0, 0) - 8.64e7,
        endTime: "",
      },
      pieOption: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // show: false,
          type: 'plain',
          orient: 'vertical',
          itemGap: 20,
          left: '66%',
          top: 'center',
          textStyle: {
            fontSize: 16,
            rich: {
              name: {
                width: 150,
                fontSize: 16,
                padding: [0,10],
              },
            },
          },
          formatter: name => {
            if (this.myPancakeChart.getOption().series && this.myPancakeChart.getOption().series.length) {
              const {data} = this.myPancakeChart.getOption().series[0]
              const target = data.find(item => item.name === name)
              return `{name|${name}} ${target.value}`
            } else {
              return ''
            }
          }
        },
        series: [
          {
            type: 'pie',
            center: ['25%', '50%'],
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ],
        // color: ['#a28460', '#e4b25f', '#c7853e', '#ccbc74'],
      }
    }
  },
  created() {
    this.searchFormData.id = this.$route.query.appId;
    this.queryData();
    this.getList();

  },
  mounted() {
    this.setPieChart();
  },
  methods: {
    //改变日周月时触发  
    agreeChange() {
      if (this.searchFormData.type == '2') {
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0] : ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1] : ''
      } else if (this.searchFormData.type == '3') {
        this.searchFormData.startTime = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime();
        this.searchFormData.endTime = "";
      } else {
        this.searchFormData.startTime = new Date().setHours(0, 0, 0, 0) - 8.64e7;
        this.searchFormData.endTime = "";
      }
      this.queryData();
      this.getList();
      this.setPieChart();
    },

    //选择时间时触发
    changeRangDate() {
      if (this.searchFormData.type == '2') {
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0] : ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1] : ''
      } else {
        this.searchFormData.endTime = "";
      }
      this.queryData();
      this.getList();
      this.setPieChart();
    },

    //获取应用概况
    queryData() {
      this.$apis.consoleSever.queryData(this.searchFormData).then(res => {
        if (res['code'] == 0 && res['data']['data']) {
          this.appData = res.data.data;
        }
      });
    },

    //设置饼状图
    setPieChart() {
      var appPieChart = document.getElementById("appPieChart");
      this.myPancakeChart = echarts.init(appPieChart);
      this.$apis.consoleSever.queryAppLinkTop(this.searchFormData).then(res => {
        if (res['code'] == 0 && res['data'].length) {
          this.pieOption.series[0].data = res.data;
          this.myPancakeChart.setOption(this.pieOption);
        } else {
          this.pieOption.series[0].data = [];
          this.myPancakeChart.setOption(this.pieOption);
        }
      });
    },

    //获取应用分发列表
    getList() {
      this.$apis.consoleSever.queryAppLinkTopList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res['data'].length) {
          this.tableData = res.data;
        } else {
          this.tableData = [];
        }
      });
    },

  }
}
</script>

<style scoped lang="scss">
.wrapBox {
  margin-top: 0;

  /deep/ .el-range-separator {
    width: 24px;
  }

  .contentBox {
    margin-top: 20px;
    display: flex;

    .titleBox {
      width: 100%;
      height: 50px;
      background: #F5F5F5;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);;
    }

    .dataBox {
      width: 30%;
      margin-right: 50px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px 4px 4px 4px;

      .data {
        margin-top: 20px;

        .title {
          padding: 0 20px;
          font-size: 16px;
          height: 30px;
          line-height: 30px;
          font-weight: bold;
        }

        .hr {
          border: 1px solid transparent;
          border-color: rgba(0, 0, 0, 0.1);
        }

        p {
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          color: #666;
          display: flex;
          justify-content: space-between;
        }
      }

    }

    .appPieBox {
      width: 65%;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px 4px 4px 4px;

      #appPieChart {
        padding: 20px;
        width: 100%;
        height: 500px;
      }

      .appPieData {
        width: 100%;
        margin-left: 50px;
        padding-top: 100px;

        p {
          width: 200px;
          display: flex;
          margin-top: 10px;
          justify-content: space-between;
        }
      }

      .noDataBox {
        width: 100%;
        height: 500px;
        text-align: center;
        line-height: 500px;
      }
    }
  }

  .listBox {
    margin-top: 30px;

    .title {
      text-align: left;
    }

    .tableBox {
      margin-top: 10px;

    }

    /deep/ .el-tabs__content {
      overflow: initial;
    }

    /deep/ .el-table__header th {
      border-bottom: 1px solid rgba(0, 0, 0, .1) !important;
      padding: 0;
      height: 32px !important;
      background: #F5F5F5;
    }
  }
}
</style>
<style>
.el-table thead.is-group th {
  background: #ebe9e9;
  color: #666;
}
</style>
